import { render, staticRenderFns } from "./problems-all.vue?vue&type=template&id=72bfcbde"
import script from "./problems-all.vue?vue&type=script&lang=js"
export * from "./problems-all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports